export default __webpack_public_path__ + "static/media/c2c.c3cc4031.jpg";